import { render, staticRenderFns } from "./UpgradeList.vue?vue&type=template&id=239a04fb&scoped=true&"
import script from "./UpgradeList.vue?vue&type=script&lang=js&"
export * from "./UpgradeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239a04fb",
  null
  
)

export default component.exports